// extracted by mini-css-extract-plugin
export var active = "_ig-2";
export var recordingDot = "_ig-1";
export var recordingIndicator = "_ig-0";